'use strict';

angular.module('jv.requisition.form.controller', [])
.controller('ReqsFormCtrl', ['$scope', 'Reqs', '$routeParams', '$location', '$filter', '$window', 'App', '$timeout', 'hasExternalSite', 'hasInternalSite', 'hireCustomer', 'hasJobNotifications', 'jvTotango', 'ApplyFormPreviewService',
function ($scope, Reqs, $routeParams, $location, $filter, $window, App, $timeout, hasExternalSite, hasInternalSite, hireCustomer, hasJobNotifications, jvTotango, ApplyFormPreviewService) {
    const JOB_STATE_CODES = {
        OPEN: 1,
        CLOSED: 2,
        FILLED: 4,
        ON_HOLD: 8,
        AWAITING_APPROVAL: 16,
        APPROVED: 32,
        REJECTED: 64,
        RETRACTED: 128,
        PENDING: 256,
        DRAFT: 512
    };

    $scope.otherLocationsChangeOccured=false;
    $scope.differentLocationsSelected = false;
    $scope.properties = angular.copy(window.properties);

    $scope.fileUploader = function(field) {
        return {
            url: '/jhire/action/resource/description',
            allowedFileTypes: ['pdf', 'doc', 'docx', 'txt', 'rtf', 'htm', 'html'],
            field: field.EId,
            multipleUpload: false
        };
    };
    $scope.hireCustomer = hireCustomer;
    $scope.templateObj = false;
    $scope.showPostOptions = false;
    $scope.showIntegrationOptions = false;
    $scope.integrations = {};
    $scope.hasInternalSite = hasInternalSite;
    $scope.hasExternalSite = hasExternalSite;
    $scope.hasJobNotifications = hasJobNotifications;
    $scope.hasConfidentialRequisitionsEnabled = $scope.properties.hasConfidentialRequisitionsEnabled;
    $scope.hasLimitedJobPostingEnabled = $scope.properties.hasLimitedJobPostingEnabled;
    $scope.isPageLoadingFormData = false;
    $scope.agencyOpts = {notifyAgency : false, showCheckbox:false, enableJobModifyNotificationAgency:false, isJobOpen:false};
    $scope.userLanguage = $window._jvselfUser.locale.language;
    $scope.fieldIdMap = {};
    // watch on distribution option for change of selection
    $scope.$watch('distributionOptions.externalCareerSite', function(newVal, oldVal) {
        // turning off the page loading flag
        if ($scope.isPageLoadingFormData) {
            $scope.isPageLoadingFormData = false;
            return;
        }
        // only show the confirmation modal for private job incase of confidential reqs are enabled
        if (newVal && !oldVal && $scope.hasConfidentialRequisitionsEnabled && $scope.hasLimitedJobPostingEnabled && $scope.postOpts.privateFlagStr === 'recruiterOnly') {
            $timeout(function() {
                $scope.confirmCheckWithPrivateFlag();
            }, 100);

        }
    });
    $scope.modals = {
        confimCareersitePosting: {
            show: false
        }
    };

    $scope.buttons = {
        open: false,
        SFA: false
    };
    // Prevent fields from rendering with old data (only use results of AJAX)
    if ($scope.requisitions) {
        $scope.requisitions.viewFields = {};
    }
    $scope.fieldMappingId = {};
    var hideFields = [];

    $scope.lockToggle = 'ico-lock';
    $scope.params = $routeParams;
    /* Stores the drivenFielIds used while rendering the field mapping*/
    $scope.drivenFields = [];

    $scope.reqdFields = [];
    $scope.required = false;
    $scope.flags.loading = true;

    /* Stores the driven field Ids which can shown on UI */
    $scope.skipableDrivenFields = [];
    $scope.result = {
        CheckBox: {},
        Array: {},
        Employee: {},
        DropDown: {},
        templateId: ((function() {
            var url = new URL($window.location.href);
            return (url && url.searchParams && url.searchParams.get('templateId')) || '';
        })())
    };
    $scope.visibilityMissing = false; // Flag To Indicate that Post Options Need To Be Filled

    $scope.employeeSelect = Reqs.employeeSelect;
    $scope.employeeSearch = Reqs.employeeSearch;
    $scope.dropDownSelect = Reqs.dropDownSelect;
    $scope.employeeMultipleSelect = Reqs.employeeMultipleSelect;
    $scope.locationMultiSelect = Reqs.locationMultiSelect;
    $scope.getMappedValues = Reqs.getMappedValues;
    $scope.getFieldMappedEmployees = Reqs.getFieldMappedEmployees;
    $scope.primaryHM = Reqs.primaryHM;
    $scope.postOpts = {};

    $scope.postOpts.privateFlagStr = 'recruiterOnly';
    $scope.postOpts.privateFlag = true;
    $scope.postOptsHelpTemplate = '<h5>' + i18n.REQ_EDIT_POSTOPTIONS_INTERNAL + '</h5>' + '<p>' + i18n.REQ_EDIT_POSTOPTIONS_INTERNAL_MSG + '</p>' + '<h5>' + i18n.REQ_EDIT_POSTOPTIONS_EXTERNAL + '</h5>' + '<p>' + i18n.REQ_EDIT_POSTOPTIONS_EXTERNAL_MSG + '</p>';

    //$scope.internal='allEmployees';
    $scope.normalized = false;

    $scope.titleField;

    $scope.validationError = false;
    $scope.dupReqIdError = false;

    // Indicates if the 'Show Incomplete Required Fields' link was clicked.
    $scope.showIncompleteReqdFields = false;

    // Flag to decide on showing the 'Next' button
    $scope.messageFlow = false;

    // When the validate errors should be shown - toggled on click on Next button.
    $scope.showError = false;

    // Types that cannot be edited through user interaction.
    $scope.nonEditableTypes = {
        Content: true,
        SerializedContent: true,
        ListedContent: true,
        RichContent: true
    };

    // These field's ng-model is different from result[fieldId].
    $scope.serializedTypesMap = {
        CheckBox: true,
        Employee: true,
        EmployeeNoDefault: true
    };

    // Limited Access Requisitions enabling check
    $scope.isLimitedJobAccessPostingAllowed = ($scope.hasConfidentialRequisitionsEnabled && $scope.hasLimitedJobPostingEnabled);

    // Check if we are in bulkEditReqs.html page
    const isBulkEditReqsPageActive = $window && $window.location && $window.location.pathname && typeof $window.location.pathname === 'string' && $window.location.pathname.includes('bulkEditReqs.html') ? true : false;

    // Check for posting & publishing - Either of these cases
    // 1. Posting Internal & Publishing Internal
    // 2. Posting External & Publishing External & Job Notifications
    // 3. Posting Limited & Confidential Requisitions Enabled & Limited Job Posting Enabled
    var updatePostingAndPublishingSection = function() {
        $scope.section = {
            postingAndPublishing: (($scope.postOpts.privateFlagStr === 'internal' && $scope.hasInternalSite) || ($scope.postOpts.privateFlagStr === 'external' && ($scope.hasExternalSite || $scope.hasJobNotifications)) || ($scope.postOpts.privateFlagStr === 'recruiterOnly' && $scope.isLimitedJobAccessPostingAllowed))
        };
    };

    $scope.confirmCheckWithPrivateFlag = function() {
        $scope.modals.confimCareersitePosting.show = true;
    };

    $scope.hideConfirmCareersitePostingModal = function() {
        $scope.modals.confimCareersitePosting.show = false;
    };

    $scope.uncheckCareersitePosting = function () {
        $scope.distributionOptions.externalCareerSite = false;
        var publishingOptions = $scope.fieldIdMap[-69];
        if (publishingOptions && $scope.result['CheckBox']?.[publishingOptions]?.['CAREERSITE']) {
            $scope.result['CheckBox'][publishingOptions]['CAREERSITE'] = false;
        }
        $scope.hideConfirmCareersitePostingModal();
    };

    // Is true if 'Job Requisitions Approval Flow' is enabled in admin settings. Used for deciding on displaying the 'Next' button
    $scope.isSFAFlowEnabled = false;

    // Holds the server responses of all uploader directives thats are attached to the description fields in the page.
    $scope.wysiwygAjaxContent = {};

    // Says whether any 'triggers approval' fields have changed after unlocking.
    $scope.approvalFieldsChanged = false;
    $scope.distributionOptions = {};
    // Holds the original value of the triggered field.
    //$scope.approvalFieldsOrigVals = {};

    // Holds the original value of all the fields(as sent by the server - on page load).
    // Used to decide if any field has changed - during navAway(page unload)
    // Used to check if the trig field value has changed inorder to decide whether or not to enable the 'Next' button
    $scope.allFieldsOrigVals = {};

    // Is true if atleast one field triggers approval. A false means there are no fields that trigger approval.
    // This also indicates if the requisition has ever been submitted for approval(Used in next button enabling/disabling)
    $scope.hasApprovalField = false;

    // These fields need special handling before and after 'add/edit/copy' flow
    // These field's ng-model is different from result[fieldId].
    // ToDo: Refactor code to use the serializedTypesMap instead of this array
    $scope.serializedTypes = ['CheckBox', 'Employee', 'EmployeeNoDefault'];


    // Flag used to highlight the driven fields
    var _noTriggerDummy = {
        indexOf: function() {
            return -1;
        }
    };
    $scope.highlightDrivenField = _noTriggerDummy;

    if (!$scope.params.id) {
        if ($scope.requisitions) {
            //$scope.params.id= $scope.requisitions.jobDetails.EId ;
            $routeParams.id = $scope.requisitions.jobDetails.EId;
        } else {
            $scope.requisitions = {};
        }
    }

    if ($location.hash().indexOf('/copy') > -1) {
        $scope.params.id = $location.hash().split('/')[2];
        $scope.copyFlow = true;
    } else {
        $scope.copyFlow = false;
    }

    //setting the job id incase we hit next/prev and then hit edit details
    if (!$scope.params.id && $scope.requisitions.jobDetails) {
        $routeParams.id = $scope.requisitions.jobDetails.EId;
    }

    //For the copy the fields should not locked, hence it will be always reverse of copyFlow flag
    $scope.locked = !$scope.copyFlow;

    var action = $scope.addOrEdit = ($window.location.pathname.search('add.html') > -1) && 'add' || 'edit';
    var options, mId = $scope.urlParams()['mId'];

    $scope.$on('onReqStatusUpdate', function(e,arg){
         if(arg.jobDetails.jobState === 'Open') {
            $scope.agencyOpts.isJobOpen=true;
         }
    });
    var processFormData = function(response) {
        $scope.isPageLoadingFormData = true;
        $scope.renderSecondaryLocation = $scope.renderSecondaryLocationField(response.viewFields);
        $scope.currencyMap = response.currencyMap;
        $scope.$parent.forumBaseUrl = response.forumBaseUrl;
        $scope.hmOnly = response.hmOnly ? response.hmOnly : false;
        $scope.hmEId = response.hireUser;
        $scope.showPostOptions = response.postSectionVisibile;
        $scope.showIntegrationOptions = angular.isDefined(response.integrations) && response.integrations.length > 0;
        $scope.isLanguageSupported = response.isLanguageSupported;
        $scope.hasOwnJobAccess = angular.isDefined(response.hasOwnJobAccess) ? response.hasOwnJobAccess : true;
        $scope.hasAccessToSFA = angular.isDefined(response.hasWriteAccessOnAllMandatoryField) ? response.hasWriteAccessOnAllMandatoryField : true;
        $scope.hasHRRestrictedRequiredFields = $.inArray('HR_Restricted', response.error_message) >= 0;
        $scope.isTitleRestricted = angular.isDefined(response.titleRestricted) ? response.titleRestricted : false;
        $scope.hasAccessToLimitedAccessJob = angular.isDefined(response.hasAccessToLimitedAccessJob) ? response.hasAccessToLimitedAccessJob : true;
        $scope.agencyOpts.notifyAgency=response.postOptions.notifyAgency;
        $scope.agencyOpts.enableJobModifyNotificationAgency=response.enableJobModifyNotificationAgency;
        $scope.agencyOpts.isJobOpen=response.isJobOpen;
        $scope.result.copyOfJobEId = response.copyOfJobEId;
        $scope.templateObj = response.templateObj;
        $scope.conditionalApprovalEnabled = response.conditionalApprovalChain;
        $scope.enableSkipApproval = response.enableSkipApproval;

        //postOptions
        if (response.postOptions) {
            //Selecting Appropriate Visibility and Distribution Options
            $scope.loadTime = true; //Want this in $watch
            if (response.postOptions.privateFlag === true) {
                $scope.postOpts.privateFlagStr = 'recruiterOnly';
            } else if (response.postOptions.privateFlag === false && response.postOptions.internal === true) {
                $scope.postOpts.privateFlagStr = 'internal';
            } else if (response.postOptions.privateFlag === false && response.postOptions.internal === false && ($scope.addOrEdit === 'edit' || $scope.copyFlow)) {
                $scope.postOpts.privateFlagStr = 'external';
            }
            $scope.distributionOptions = {};
            if (response.postOptions.notification === true && !response.postOptions.internal && !response.postOptions.privateFlag) {
                $scope.distributionOptions.jobNotification = true;
            }
            if (response.postOptions.careerSite === true && !response.postOptions.internal && response.postOptions.privateFlag && $scope.isLimitedJobAccessPostingAllowed) {
                $scope.distributionOptions.externalCareerSite = true;
            }
            if (response.postOptions.careerSite === true && response.postOptions.internal && !response.postOptions.privateFlag) {
                $scope.distributionOptions.internal = true;
            }
        }

        //integrationOptions
        if($scope.showIntegrationOptions) {
            angular.forEach(response.integrations, function(integration) {
                integration.entityStatusValue = integration.entityStatus === 'ENABLED';
            });
        }
        $scope.integrations = response.integrations;

        $scope.requisitions = angular.extend($scope.requisitions, response);
        $scope.reqTemplateId = $scope.result.templateId ? $scope.result.templateId : $scope.requisitions.jobDetails.requisitionTemplateEId;
        /*BUG:21312 removing JobLink field if REQ is not external in edit MODE*/
        if ($scope.postOpts.privateFlagStr !== 'external') {
            angular.forEach($scope.requisitions.viewFields, function(vField, index) {
                if (vField.fieldId === -47) {
                    $scope.requisitions.viewFields.splice(index, 1);
                }
            });
        }

        $scope.fieldIdMap = $scope.requisitions.viewFields.reduce((list, cur) => ({ ...list, [cur.fieldId]: cur.EId }), {});

        if ($scope.requisitions.triggeredFields && $scope.requisitions.triggeredFields.length > 0) {
            $scope.fieldMapPreProcess();
        }
        if (response.hasJobApproval) {
            $scope.isSFAFlowEnabled = true;
        }

        var approverEditingRequisition = false;

        if ($scope.addOrEdit === 'add') {
            $scope.buttons.SFA = $scope.isSFAFlowEnabled;
            $scope.buttons.open = !$scope.isSFAFlowEnabled;
            $scope.alertLanguageNotSupported();
        } else if ($scope.addOrEdit === 'edit') {
            $scope.alertLanguageNotSupported();
            const jobStateCode = $scope?.requisitions?.jobDetails?.state;
            const jobStatesToCheckSFA = [JOB_STATE_CODES.DRAFT, JOB_STATE_CODES.REJECTED, JOB_STATE_CODES.RETRACTED];
            const matchesJobStateForSFA = jobStatesToCheckSFA.includes(jobStateCode);
            //If the approver has the permission to edit the requisition(from message details page)
            if (mId && jobStateCode === JOB_STATE_CODES.AWAITING_APPROVAL) {
                approverEditingRequisition = true;
                $scope.buttons.SFA = true;
                $scope.buttons.open = false;
            } else {
                $scope.buttons.SFA = $scope.isSFAFlowEnabled && matchesJobStateForSFA;
                $scope.buttons.open = !$scope.isSFAFlowEnabled && matchesJobStateForSFA;
            }
        }

        //Permission to submit for approval.(Honor this for all scenarios except when approver has access to edit requisition)
        //if views are present i.e edit mode, honour the evaluated perms in views
        if (!approverEditingRequisition && ((!$scope.requisitions.views && !$scope.requisitions.allowToSubmitOrOpen) ||
            ($scope.requisitions.views && !$scope.requisitions.views.allowToSubmitOrOpen))) {
            $scope.buttons.SFA = false;
            $scope.buttons.open = false;
        }

        // Using urlParams instead of $location as $location search() params are not crossbrowser compatible on redirection.
        if (response.isEditApprover) {
            $scope.messageFlow = true;
        }

        $scope.flags.loading = false;
        $scope.init();
    };

    var handleApiFailure = function(response){
        var errorMessage = response.data.errorMessage || '';
        if(['MISSING_TEMPLATE_ID','INVALID_OR_INACTIVE_TEMPLATE'].includes(errorMessage)){
            $scope.cancel();
        }
    };

    var fetchReqsEditForm = function() {
        var fetchReqsOptions = {
            mId: mId
        };
        Reqs[action](
            $scope.params.id, // requisition id
            processFormData, // success callback
            fetchReqsOptions, // options
            handleApiFailure // failure callback
        );
    };

    // ToDo: Check on pagination and also check for tabClicked var
    if (!$scope.requisitions.jobDetails && action !== 'add' && $scope.activeTab('#/details-edit')) {

        options = angular.extend({
            tabs: 3,
            paginated: $scope.flags.paginated
        }, $scope.params);
        if (mId) {
            options.mId = mId;
        }
        var callback = function(requisitions) {
            if (requisitions.forumBaseUrl) {
                $scope.$root.forumBaseUrl = requisitions.forumBaseUrl;
            }
            angular.extend($scope.requisitions, requisitions);
            //  Above condition should ideally never happen, confirm with BE and remove it.
            if ($scope.flags.paginated) {
                $scope.flags.paginated = false;
            }
            $scope.params.id = $scope.requisitions.jobDetails.EId;
            $scope.flags.loading = false;
            $scope.params.id = requisitions.jobDetails.EId;
            //Fetch the notes count only if the notes tab is visible
            if (requisitions.views.notesTab) {
                Reqs.getNotesCount($scope.params.id, function(response) {
                    $scope.$parent.requisitions.notesCount = response.notesCount;
                });
            }
            if (requisitions.msgInfo) {
                $scope.showMsg(requisitions.msgInfo);
            }
            processFormData(requisitions);
        };

        Reqs.details(options, callback, handleApiFailure);
    } else {
        !isBulkEditReqsPageActive && fetchReqsEditForm();
    }

    $scope.alertLanguageNotSupported = function(showMessage) {
        if (showMessage || (!angular.isUndefined($scope.isLanguageSupported) && !$scope.isLanguageSupported)) {
            $scope.showMsg('LANGUAGE_NOT_SUPPORTED', false, 'error');
        }
    };

    /**
     * Put in any init code for the controller. This method initializes the reapproval trigger modal
     * and the date widget.  This is called from the ajax callback so that necessary dom elements are in place.
     */
    $scope.init = function() {
        var eventData = $._data(document, 'events');
        if (eventData) {
            $scope.liveEvents = eventData.click;
            eventData.click = '';
        }
        $('.jv-reqEditTabMenu li').not('.active').on('click', $scope.navAway);
    };

    $scope.unlock = function() {
        if ($scope.locked) {
            postStatusChangeModal(i18n.REAPPROVAL_MODAL_WARNING_TITLE, i18n.REAPPROVAL_MODAL_WARNING_MESSAGE, function() {
                $scope.locked = false;
                $scope.result.unlocked = true;
                $scope.lockToggle = 'ico-unlock';
                $scope.buttons.SFA = $scope.addOrEdit === 'edit' && $scope.isSFAFlowEnabled; // !addOrEdit = edit mode
            }, function() {
                $scope.result.unlocked = false;
            });
        }
    };

    function showLimitedRequisitionNotAllowed() {
        $scope.modal.show = true;
        $scope.modal.title = i18n.REQS_LIMITED_ACCESS;
        $scope.modal.body = i18n.REQ_ADD_EDIT_LIMITED_ACCESS_ERROR_MESSAGE;
        $scope.modal.buttons = [{
            'class': 'btn',
            'label': i18n.CLOSE,
            'click': function() {
                $scope.modal.show = false;
            }
        }];
    }

    function postStatusChangeModal(errorTitle, errorMessage, okCallback, cancelCallback) {
        okCallback = (okCallback || angular.noop), cancelCallback = (cancelCallback || angular.noop);
        $scope.modal.show = true;
        $scope.modal.title = errorTitle;
        $scope.modal.body = errorMessage;
        $scope.modal.buttons = [];
        $scope.modal.ok = function() {
            $scope.modal.show = false;
            okCallback();
        };
        $scope.modal.cancel = function() {
            $scope.modal.show = false;
            cancelCallback();
        };
    }

    function postSubmitHMErrors(errorTitle, errorMessage, okName, isCancel, cancelName, okCallback, cancelCallback) {
        okCallback = (okCallback || angular.noop), cancelCallback = (cancelCallback || angular.noop);
        $scope.modal.show = true;
        $scope.modal.title = errorTitle;
        $scope.modal.body = errorMessage;
        $scope.modal.buttons = [{
            'class': 'btn',
            'label': okName,
            'click': function() {
                $scope.modal.show = false;
                okCallback();
            }
        }];

        if (isCancel) {
            var cancelBtn = {
                'class': 'cancel',
                'label': cancelName,
                'click': function() {
                    $scope.modal.show = false;
                    cancelCallback();
                }
            };
            $scope.modal.buttons.push(cancelBtn);
        }
    }

    $scope.isValidCustomFieldContent = function(valueList, value) {
        var isValidContent = false;
        angular.forEach(valueList, function(fieldVal) {
            if (!isValidContent && fieldVal.key === value) {
                isValidContent = true;
            }
        });
        return isValidContent;
    };

    // $scope.scrollToRequired = function(elem){
    //     if (!elem) {
    //         elem = $('.field.required.highlight:first');
    //     }
    //     var destination = $(elem).offset().top;
    //     $('html:not(:animated),body:not(:animated)').animate({ scrollTop: destination-20}, 500 );
    // };

    // Filters values that are not user presentable
    var sanitize = function(field) {
        if (field) {
            var type = field.renderedType || field.fieldType;
            // '0' is what BE stores as default values for these fields, so FE is supposed to sanitize it into a user presentable value(duh!).
            if (type === 'Wysiwyg' && field.value === '0') {
                field.value = '';
            }
            if (field.fieldId === -37 && field.value === 'Undefined') {
                hideFields.push(field.fieldId);
            }
        }
    };

    var isFieldSame = function(field) {
        // Perf: Having multiple return points instead of a single 'result' variable and single return point(see angular.equals).
        var type = field.renderedType,
            newVal = $scope.modelVal(field),
            oldVal = $scope.allFieldsOrigVals[field.EId],
            result = true;

        // Code smell. Why's: Lookup: Normalize
        if (typeof oldVal === 'undefined' && newVal === '') {
            return true;
        }

        if (type !== 'CheckBox') {
            if (type === 'Employee') {
                if (newVal && newVal.hasOwnProperty('EId')) {
                    newVal = newVal.EId;
                }
            } else if (type === 'DropDown' && oldVal === '0') { // Quickfix till #9306 is fixed by BE
                oldVal = '';
            } else if (type === 'Wysiwyg') {
                // ToDo: Understand how tinyMCE works from Dean and remove this code smell!
                // Spoke to BE and seems like this smell has to stink around for some time.
                if (oldVal) {
                    oldVal = oldVal.replace(new RegExp('<br>', 'g'), '<br />');
                }
                if (newVal) {
                    if (newVal.slice(0, 3) === '<p>' && oldVal && oldVal.slice(0, 3) !== '<p>') {
                        oldVal = '<p>' + oldVal + '</p>';
                    }
                }
            }
            if (!angular.equals(oldVal, newVal) || (field.fieldId===-8 && $scope.otherLocationsChangeOccured)) {
                result = false;
            }
        } else {
            // For CheckBox
            $.each(newVal, function(cbKey) {
                if (oldVal && oldVal.hasOwnProperty(cbKey)) {
                    if (!newVal[cbKey]) {
                        result = false;
                        return false;
                    }
                }
                if (oldVal && !oldVal.hasOwnProperty(cbKey)) {
                    if (newVal[cbKey]) {
                        result = false;
                        return false;
                    }
                }
            });
        }

        return result;
    };

    /**
     * Returns a normalized type of input
     * TODO: Move to a RequisitionModel
     * @param field object reference to original field
     * @param {normalize} optional boolean whether or not to normalize the field
     */

    $scope.type = function(field, normalize) {
        var postOptions = ['Notification', 'AvailableTo', 'Career Site', 'Private', 'Internal Only'];
        var type = field.fieldType || field.objectType;
        var checkBoxes, employees, emp;
        // Holds the model value of a field that can be compared to its original model value - used for serialized types.
        // var modelVal;
        normalize = normalize && !field.normalized;
        if (field.fieldId === -1 && field.name !== 'First Name') {
            $scope.titleField = field.EId;
        }
        if (field.fieldType && ($.inArray(field.fieldType, $scope.serializedTypes) < 0) && normalize && field.value) {
            if (field.fieldType === 'Name' && (field.name === 'Title' || field.name === 'Requisition ID')) {
                $scope.result[field.EId] = field.value.trim();
            } else {
                if (field.fieldType === 'DropDown') {
                    if (field.readOnly) {
                        $scope.result[field.EId] = field.value || '';
                    } else {
                        var dd = $scope.result['DropDown'] = $scope.result['DropDown'] || {};
                        if (field.value) {
                            sanitize(field);
                            dd[field.EId] = field.value;
                        } else {
                            dd[field.EId] = '';
                        }
                    }

                    //used to render other locations dropdown
                    if (field.fieldId === -8) {
                        var data = field.data;
                        $scope.result.otherLocations = [];
                        angular.forEach(data, function(location) {
                            $scope.result.otherLocations.push(location.EId);
                        });
                    }
                } else if( type === 'Currency'){
                    $scope.result[field.EId] =  {
                        currencyCode: field.unitOfMeasure,
                        value: angular.copy(field.value)
                    };
                } else {
                    $scope.result[field.EId] = field.value;
                }
            }
        }
        // Cases that should not be rendered
        if ($.inArray(field.name, postOptions) > -1) {
            type = 'hide';
        }
        // Checks to see if a form input should be used or if value should be rendered
        if (type === 'Text') {
            if (field.fieldType) {
                type = 'Wysiwyg';
            } else {
                type = 'Content';
            }
        }
        // Checks to see if the value would have HTML in it
        // Make triggersApproval fields editable during copy flow.
        if (field.readOnly || ($scope.params.id && field.triggersApproval && $scope.locked && !$scope.copyFlow)) {
            if (type === 'Wysiwyg') {
                type = 'RichContent';
            } else if ($.inArray(type, $scope.serializedTypes) > -1) {
                type = 'SerializedContent';
                field.initContent = false;
            } else if (field.fieldType === 'DropDown' && typeof field.objectType === 'undefined') {
                type = 'ListedContent';
            } else {
                type = 'Content';
            }
        }

        // SerializedContent - Displaying the Employee name/s instead of the eid(value attribute) when it is readonly or locked.
        // Also using initContent instead of 'normalize' so that when the field is unlocked, the normalization process must happen for the
        // employee values to be displayed.
        if (type === 'SerializedContent' && !field.initContent) {
            var displayValues = [],
                displayContent = '',
                temp = {},
                found = false;
            if (field.fieldType === 'Employee' && field.values && field.values.length > 0) {
                if (field.values[0] && field.values[0].value) {
                    displayContent = field.values[0].value;
                }
            } else if (field.value) {
                displayValues = field.value.split('\n');

                if (angular.isArray(field.values) && field.values.length > 0) {
                    // Iterate twice (2n Vs N*n)
                    angular.forEach(displayValues, function(value) {
                        temp[value] = true;
                    });
                    angular.forEach(field.values, function(obj) {
                        if (temp[obj.key]) {
                            if (found) {
                                displayContent = displayContent + ', ' + obj.value;
                            } else {
                                displayContent = displayContent + obj.value;
                                found = true;
                            }
                        }
                    });
                }
            }
            field.displayContent = displayContent;
            // Avoiding this block from executed everytime the type function is invoked(which is too many times)
            field.initContent = true;
        }

        // Deserializing checkbox values && Putting checkboxes under the key 'CheckBox' in the result object(easier and faster for serialization later)
        if (type === 'CheckBox' || (type === 'SerializedContent' && field.fieldType === 'CheckBox')) {
            if (normalize) {
                $scope.result['CheckBox'] = $scope.result['CheckBox'] || {};
                checkBoxes = $scope.result['CheckBox'];
                checkBoxes[field.EId] = checkBoxes[field.EId] || {};
                field.multiple = true;
                if (!angular.isObject(field.value)) {
                    // Serialize/Deserialize value into object literal
                    var fieldValues = field.value;
                    if (angular.isString(fieldValues)) {
                        angular.forEach(fieldValues.split('\n'), function(value) {
                            if (value && $scope.isValidCustomFieldContent(field.values, value)) {
                                checkBoxes[field.EId][value] = true;
                            }
                        });
                    }
                }
            }
        }

        if (type === 'Employee' || type === 'EmployeeNoDefault') {
            if (field.length !== 1) {
                type = 'EmployeeMultiple';
            } else if (type === 'EmployeeNoDefault') {
                type = 'Employee';
            }
        }
        var fieldIdPattern = /-16|-17|-21|-61/i;
        if (type === 'EmployeeMultiple' || (type === 'SerializedContent' && (fieldIdPattern.test(field.fieldId) || field.fieldId > 0))) {
            if (normalize) {
                if (field.fieldType === 'Employee' || field.fieldType === 'EmployeeNoDefault') {
                    $scope.result['Array'] = $scope.result['Array'] || {};
                    employees = $scope.result['Array'];
                    employees[field.EId] = employees[field.EId] || [];
                    if (field.fieldId === -17) {
                        $scope.result.otherHM = [];
                        if ($scope.requisitions.jobDetails && $scope.requisitions.jobDetails.primaryHiringManagerEId && ($scope.addOrEdit === 'edit' || $scope.copyFlow)) {
                            $scope.result.Array[field.EId] = $scope.requisitions.jobDetails.primaryHiringManagerEId;
                        } else if ($scope.addOrEdit === 'add' || (($scope.addOrEdit === 'edit' || $scope.copyFlow) && $scope.requisitions.jobDetails && angular.isUndefined($scope.requisitions.jobDetails.primaryHiringManagerEId))) {
                            $scope.result.Array[field.EId] = field.value && field.value.trim().split('\n')[0];
                        } else if (isBulkEditReqsPageActive) {
                            $scope.result.Array[field.EId] = field.value && field.value.trim().split('\n')[0];
                        }
                    }
                    // Recruiter field
                    if (field.fieldId === -16) {
                        $scope.result.otherRecruiters = [];
                        if ($scope.requisitions.jobDetails && $scope.requisitions.jobDetails.primaryRecruiterEId && ($scope.addOrEdit === 'edit' || $scope.copyFlow)) {
                            $scope.result.Array[field.EId] = $scope.requisitions.jobDetails.primaryRecruiterEId;
                        } else if ($scope.addOrEdit === 'add' || (($scope.addOrEdit === 'edit' || $scope.copyFlow) && $scope.requisitions.jobDetails && angular.isUndefined($scope.requisitions.jobDetails.primaryRecruiterEId))) {
                            $scope.result.Array[field.EId] = field.value && field.value.trim().split('\n')[0];
                        } else if (isBulkEditReqsPageActive) {
                            $scope.result.Array[field.EId] = field.value && field.value.trim().split('\n')[0];
                        }
                    }

                    if (!angular.isObject(field.value)) {
                        var values = field.value;
                        if (field.fieldId === -17) {
                            if (values && angular.isString(values) && ($scope.addOrEdit === 'edit' || $scope.copyFlow)) {
                                angular.forEach(values.split('\n'), function(value) {
                                    if (value) {
                                        if ($scope.requisitions && $scope.requisitions.jobDetails && $scope.requisitions.jobDetails.primaryHiringManagerEId !== value) {
                                            $scope.result.otherHM.push(value);
                                        }
                                    }
                                });
                            }
                        } else if (field.fieldId === -16) {
                            if (values && angular.isString(values) && ($scope.addOrEdit === 'edit' || $scope.copyFlow)) {
                                angular.forEach(values.split('\n'), function(value) {
                                    if (value) {
                                        if ($scope.requisitions && $scope.requisitions.jobDetails && $scope.requisitions.jobDetails.primaryRecruiterEId !== value) {
                                            // add all other recruiters; exclude the one added as primary
                                            if($scope.result.Array[field.EId] !== value){
                                                $scope.result.otherRecruiters.push(value);
                                            }
                                        }
                                    }
                                });
                            }
                        } else {
                            if (values && angular.isString(values)) {
                                angular.forEach(values.split('\n'), function(value) {
                                    if (value) {
                                        employees[field.EId].push(value);
                                    }
                                });
                            }
                        }
                    }
                }
            }
        } else if ((type === 'Employee' || (field.fieldType === 'EmployeeNoDefault' && field.triggersApproval)) && normalize) {
            $scope.result['Employee'] = $scope.result['Employee'] || {};
            emp = $scope.result['Employee'];
            if ($scope.locked) {
                emp[field.EId] = field.data ? field.data[0] : '';
            } else {
                emp[field.EId] = field.value ? field.value : '';
            }
        }


        // If it is SerializedContent(triggersApproval and not readOnly), normalization process must happen for this field when it is unlocked, so preventing from setting it to true right now.
        if (normalize && type !== 'SerializedContent') {
            field.normalized = true;
        }
        if (action === 'edit' && field.retainDeletedValue && !!field.value && (type === 'Radio')) {
            if ($filter('filter')(field.values, {
                    key: field.value
                }).length === 0) {
                field.values.unshift({
                    key: field.value,
                    value: field.value
                });
            }
        }
        // Caching the rendered type
        field.renderedType = type;

        if (normalize && !$scope.allFieldsOrigVals.hasOwnProperty(field.EId)) {
            if (field.fieldType === 'DropDown' && field.values) {
                var value = $scope.modelVal(field);
                if (!angular.isObject(value)) {
                    $scope.allFieldsOrigVals[field.EId] = $scope.filterOnKeyAndReturnObj(field.values, field.value);
                } else {
                    $scope.allFieldsOrigVals[field.EId] = angular.copy($scope.modelVal(field));
                }
            } else {
                $scope.allFieldsOrigVals[field.EId] = angular.copy($scope.modelVal(field));
            }
        }


        if (field.triggersApproval) {
            if ($scope.isSFAFlowEnabled && $scope.result.unlocked && $scope.allFieldsOrigVals.hasOwnProperty(field.EId)) {
                if (!isFieldSame(field)) {
                    field.changed = true;
                } else if (field.changed) {
                    field.changed = false;
                }
            }

            // Has atleast one trigger approval field.
            if (!$scope.hasApprovalField) {
                $scope.hasApprovalField = true;
            }
        }

        if (normalize) {
            sanitize(field);
        }

        return type;
    };

    $scope.fieldClasses = function(field) {
        var classes = '';
        if (field.required) {
            classes += ' required';
            if ($scope.highlightEmpty && (
                    (typeof (!$scope.result[field.EId] && $scope.result[field.EId]) !== 'undefined') || (field.fieldType === 'DropDown' && ($.grep(field.values, function(val) {
                        return val.key === $scope.result[field.EId];
                    }).length === 0)) || ($scope.result['Array'][field.EId] && $.isEmptyObject($scope.result['Array'][field.EId])) || ($scope.result['CheckBox'][field.EId] && $.isEmptyObject($scope.result['CheckBox'][field.EId])) || (typeof $scope.result[field.EId] === 'undefined' && typeof $scope.result['Array'][field.EId] === 'undefined' && typeof $scope.result['CheckBox'][field.EId] === 'undefined')
                )) {
                classes += ' highlight';
            }
        }
        if (field.fieldId === -1) {
            classes += ' required';
        }
        if ($scope.showIncompleteReqdFields && !field.readOnly && (field.required || field.fieldId === -1) && $scope.isEmpty(field)) {
            classes += ' incomplete';
        }
        return classes;
    };

    /**
     * Says if the passed in field can be edited by the user at this point on the form.
     */
    var isEditable = function(field) {
        var result = true,
            type;

        if (field.readOnly || (field.triggersApproval && $scope.locked)) {
            result = false;
        } else {
            type = field.renderedType || $scope.type(field);
            if ($scope.nonEditableTypes[type]) {
                result = false;
            }
            /*Commenting this out for bug 13422*/
            // }else if(  (type === 'Employee' || type === 'EmployeeMultiple') && !field.values){
            //     result = false;
            // }
        }

        return result;
    };

    $scope.modelVal = function(field) {
        var type = field.renderedType || $scope.type(field),
            serializedRenderedTypes = {
                Employee: true,
                EmployeeMultiple: true,
                CheckBox: true,
                DropDown: true
            },
            modelVal;
        if (!serializedRenderedTypes[type]) {
            modelVal = $scope.result[field.EId];
        } else if (type === 'CheckBox') {
            modelVal = $scope.result['CheckBox'][field.EId];
        } else if (type === 'EmployeeMultiple') {
            modelVal = $scope.result['Array'][field.EId];
        } else if (type === 'Employee') {
            modelVal = $scope.result['Employee'][field.EId];
        } else if (type === 'DropDown') {
            if (field.readOnly) {
                modelVal = $scope.result[field.EId];
            } else {
                modelVal = $scope.result.DropDown[field.EId];
            }
        }
        return modelVal;
    };
    var _setModelValue = function(field, value) {
        var type = field.fieldType,
            serializedRenderedTypes = {
                Employee: true,
                EmployeeMultiple: true,
                CheckBox: true,
                DropDown: true
            };
        if (type === 'EmployeeNoDefault') {
            if (field.fieldId === -16 || field.fieldId === -16 || field.fieldId === -21) {
                type = 'EmployeeMultiple';
            } else {
                type = 'Employee';
            }
        }
        if (!serializedRenderedTypes[type] || field.readOnly) {
            $scope.result[field.EId] = value || '';
        } else if (type === 'CheckBox') {
            var checkBoxValue = {};
            if (value) {
                angular.forEach(value.trim().split('\n'), function(cbSelect) {
                    if (cbSelect && cbSelect !== '') {
                        checkBoxValue[cbSelect] = true;
                    }
                });
            }
            $scope.result['CheckBox'][field.EId] = checkBoxValue;
        } else if (type === 'EmployeeMultiple') {
            var multipleArray = [];
            if (value) {
                angular.forEach(value.trim().split('\n'), function(arrayVal) {
                    if (arrayVal && arrayVal !== '') {
                        multipleArray.push(arrayVal);
                    }
                });
            }
            $scope.result['Array'][field.EId] = multipleArray;
        } else if (type === 'Employee') {
            $scope.result['Employee'][field.EId] = value || '';
        } else if (type === 'DropDown') {
            if (field.readOnly) {
                $scope.result[field.EId] = value || '';
            } else {
                $scope.result.DropDown[field.EId] = value || '';
            }
        }
    };

    $scope.modelExpr = function(field) {
        var type = field.renderedType || $scope.type(field),
            serializedRenderedTypes = {
                EmployeeMultiple: true,
                CheckBox: true,
                DropDown: true
            },
            modelVal;
        if (!serializedRenderedTypes[type]) {
            modelVal = 'result[' + field.EId + ']';
        } else if (type === 'CheckBox') {
            modelVal = 'result["CheckBox"][' + field.EId + ']';
        } else if (type === 'EmployeeMultiple') {
            modelVal = 'result["Array"][' + field.EId + ']';
        } else if (type === 'Employee') {
            modelVal = 'result["Employee"][' + field.EId + ']';
        } else if (type === 'DropDown') {
            if (field.readOnly) {
                modelVal = 'result[' + field.EId + ']';
            } else {
                modelVal = 'result["DropDown"][' + field.EId + '].key';
            }
        }

        return modelVal;

    };

    $scope.isEmpty = function(field) {
        var result = true,
            modelVal;
        modelVal = $scope.modelVal(field);
        if (!modelVal) {
            result = true;
        } else {
            if (field.fieldType === 'CheckBox' && !$.isEmptyObject(modelVal)) {
                angular.forEach(modelVal, function(value) {
                    if (value) {
                        result = false;
                    }
                });
            } else if (typeof modelVal === 'boolean') {
                result = !modelVal;
            } else if (angular.isString(modelVal)) {
                modelVal = modelVal.trim();
                result = !modelVal;
            } else if (angular.isArray(modelVal)) {
                if (modelVal.length > 0) {
                    result = false;
                }
            } else if (angular.isObject(modelVal)) {
                if(field.fieldType === 'Currency'){
                    if(modelVal.currencyCode && modelVal.value){
                        result = false;
                    }
                }else if(!$.isEmptyObject(modelVal)){
                    result = false;
                }
            }
        }
        return result;
    };

    var emptyReqdFields = function() {
        if (isBulkEditReqsPageActive) {
            return [];
        }
        return $filter('filter')($scope.requisitions.viewFields, function(field) {
            if ($scope.addOrEdit === 'edit' && !$scope.copyFlow && field.triggersApproval && $scope.locked) {
                return false;
            } else {
                if (!isEditable(field)) {
                    return false;
                }
                if (field.required || field.fieldId === -1) {
                    if ($scope.requisitions._triggeredFields && $scope.requisitions._triggeredFields[field.fieldId] && $scope.requisitions._triggeredFields[field.fieldId].required && !$scope.modelVal($scope.requisitions._triggeredFields[field.fieldId]) && $('#field' + $scope.requisitions._triggeredFields[field.fieldId].EId).parents('div [ng-repeat]').is(':visible')) {
                        return true;
                    }
                    if ($scope.requisitions._triggeredFields && $scope.requisitions._triggeredFields[field.fieldId] && $.inArray(field.fieldId,$scope.skipableDrivenFields) < 0) {
                        return false;
                    }
                    if ($scope.isEmpty(field) || (field.fieldType === 'Number' && $scope.isNumberValid($scope.result[field.EId]))) {
                        return true;
                    }
                }
                return false;
            }
        });
    };

    var anyReqdFieldsEmpty = function() {
        var fields = emptyReqdFields();
        return fields ? fields.length > 0 : true;
    };

    $scope.isNextDisabled = function() {
        var disabled = true;
        if ($scope.copyFlow || action === 'add' || !$scope.hasApprovalField) {
            // Can't use the inbuilt form.$invalid or $errors the ng-model for checkbox is not empty when no values are chosen(select and unselect).
            disabled = anyReqdFieldsEmpty();
        } else if (action === 'edit') {
            if ($scope.messageFlow) {
                disabled = false;
            } else {
                disabled = !$scope.hasApprvFieldChanged() || anyReqdFieldsEmpty();
            }
        }
        return disabled;
    };

    $scope.hasApprvFieldChanged = function() {
        if ($scope.locked && $scope.addOrEdit === 'edit' && !$scope.copyFlow) {
            return true;
        }
        var fields = $filter('filter')($scope.requisitions.viewFields, {
            'changed': true
        });
        if (fields && fields.length > 0) {
            return true;
        } else {
            return false;
        }
    };

    /**
     * Method used to show the details on click of Cancel.
     *
     * */
    $scope.cancel = function() {
        $scope.showIncompleteReqdFields = false;
        var eventData = $(document).data('events');
        if (eventData) {
            eventData.click = $scope.liveEvents;
        }

        if (jQuery.fn.jquery.split('.')[0] === '3') {
            $('.jv-reqEditTabMenu li').not('.active').off('click', $scope.showNavAway);
        } else {
            $('.jv-reqEditTabMenu li').not('.active').unbind('click', $scope.showNavAway);
        }

        
        if ($scope.params.id || $scope.copyFlow) {
            //edit
            if (jQuery.fn.jquery.split('.')[0] === '3') {
                angular.element($window.document).off('beforeunload');
            } else {
                angular.element($window.document).unbind('beforeunload');
            }
            
            if ($scope.copyFlow) {
                //copy
                window.location = 'tabs.html#/details/' + $scope.params.id + window.location.href.split($scope.params.id)[1];
            }
            $location.path(('/details/' + $scope.params.id + '/' + $scope.params.index + '/' + $scope.params.count + '/' + $scope.params.query).replace(/\/undefined/gi, ''));
        } else {
            //add
            window.location = 'list.html';
        }
    };


    $scope.$watch('postOpts.privateFlagStr', function(newVal) {
        //If visibility was missed and next was pressed, $scope.visibilityMissing will be true. If a value is selected, we should remove the error message.
        if (newVal !== '' && $scope.visibilityMissing === true) {
            $scope.visibilityMissing = false;
        }
        if (newVal === 'internal' || newVal === 'external') {
            //Internal and External careerSites are mutually exclusive as per the contract. So one of them should be set to false
            $scope.distributionOptions['externalCareerSite'] = false;
            $scope.distributionOptions['internalCareerSite'] = false;
            if ($scope.loadTime) {
                $scope.loadTime = false;
                if (($scope.requisitions.postOptions && $scope.requisitions.postOptions['careerSite']) || $scope.addOrEdit === 'add') {
                    $scope.distributionOptions[newVal + 'CareerSite'] = true;
                    $scope.distributionOptions['jobNotification'] = $scope.distributionOptions['jobNotification'] || false;
                }
            } else {
                $scope.distributionOptions[newVal + 'CareerSite'] = true;
            }
        }
        //Suppose the user first selects internal or external, there might be a change that these might be set to true.
        //Confidential Requisitions related change, allowing careersite option for recruiterOnly
        if (newVal === 'recruiterOnly') {
            $scope.distributionOptions['internalCareerSite'] = false;
            $scope.distributionOptions['externalCareerSite'] = false;
            $scope.distributionOptions['jobNotification'] = false;
        }
        // update section.postingAndPublishing to display Distribution options section
        updatePostingAndPublishingSection();
    });
    /**
     * Method used to save the details on click of Save.
     *
     * */
   var mergePrimaryAndOtherHM = function(postData) {
        $filter('filter')($scope.requisitions.viewFields, function(field) {
            if (field.fieldId === -17) {
                if (postData.Array[field.EId]) {
                    var tempArr = [];
                    tempArr.push(postData.Array[field.EId]);
                    tempArr.push.apply(tempArr, postData.otherHM);
                    postData.Array[field.EId] = tempArr;
                }
            }
        });
        return postData;
    };

    var scrolled = false;

    var checkUserInList = function(userToCheck, userList) {
        var userExists = false;
        if (angular.isArray(userList)) {
            var usersInList = $.grep(userList, function(usr) {
                if (angular.isObject(usr)) {
                    return usr.EId === userToCheck;
                } else {
                    return usr === userToCheck;
                }
            });
            userExists = !!usersInList.length;
        } else {
            if (angular.isObject(userList)) {
                userExists = userList.EId === userToCheck;
            } else {
                userExists = userList === userToCheck;
            }
        }
        return userExists;
    };

    var isLimitedAccessJob = function() {
                var postingTypeStandardField = $scope.fieldIdMap[-68];
                return postingTypeStandardField ? $scope.result['DropDown']?.[postingTypeStandardField]?.key === '2': $scope.postOpts.privateFlagStr === 'recruiterOnly';
    };

    var isCurrentHMselected = function() {
        var isSelected = true;
        // User with {Non-RBAC: Non HM} and {RBAC-Admin} never have these flags.. hence evalaute to True
        if ($scope.hmEId || $scope.hmOnly) {
            // The condition evaluates only when user is {Non-RBAC:Only HM},{RBAC:Non-Admin}
            isSelected = false;
            angular.forEach($scope.requisitions.viewFields, function(field) {
                if ($.inArray(field.fieldId, [-16, -17, -61]) >= 0) {
                    isSelected = isSelected || checkUserInList($scope.hmEId, $scope.result.Array[field.EId]);
                    if (field.fieldId === -17) {
                        isSelected = isSelected || checkUserInList($scope.hmEId, $scope.result.otherHM);
                    }
                }
            });
        }
        var selectedVal = Boolean(isSelected);
        return selectedVal;
    };

    // checks if user exists in the fields list by fieldId
    var checkUserInUserListByFieldId = function(userToCheck, fieldId) {
        var isSelected = false;
        var HM_FIELD_ID = -17; //FieldId of Hiring Manager field is -17
        angular.forEach($scope.requisitions.viewFields, function(field) {
            if (field.fieldId === fieldId) {
                isSelected = isSelected || checkUserInList(userToCheck, $scope.result.Array[field.EId]);
                if (field.fieldId === HM_FIELD_ID) {
                    isSelected = isSelected || checkUserInList(userToCheck, $scope.result.otherHM);
                }
            }
        });
        var selectedVal = Boolean(isSelected);
        return selectedVal;
    };

    /**
     * Method used to save the Recruiter details on click of Save.
     *
     * */
    var mergePrimaryAndOtherRecruiters = function(postData) {
        $filter('filter')($scope.requisitions.viewFields, function(field) {
            if (field.fieldId === -16) {
                if (postData.Array[field.EId]) {
                    var tempArr = [];
                    tempArr.push(postData.Array[field.EId]);
                    tempArr.push.apply(tempArr, postData.otherRecruiters);
                    postData.Array[field.EId] = tempArr;
                }
            }
        });
        return postData;
    };

    var scrollToEmptyField = function(fields) {
        if (isBulkEditReqsPageActive) {
            return;
        }
        
        if (!fields) {
            return;
        }
        $scope.incompleteRequired = $scope.incompleteRequired || {};
        angular.forEach(fields, function(field) {
            $scope.incompleteRequired[field.EId] = 0;
        });
        $scope.validationError = true;
        $scope.showError = true;
        var typeToTest = $scope.type(fields[0]);
        var patternToTest = /Employee|DropDown/i;
        if (patternToTest.test(typeToTest)) {
            $scope.scrollTo('s2id_field' + fields[0].EId);
        } else {
            $scope.scrollTo('field' + fields[0].EId);
        }
    };

    var hasNotifyAgencyChange = function() {
        if(!$scope.agencyOpts.showCheckbox) {
            return false;
        } else {
            return $scope.agencyOpts.notifyAgency;
        }
    };

    var save = function(action) {
        var _fail = false;
        scrolled = false;
        if (!$scope.postOpts.privateFlagStr) {
            _fail = true;
        }
        var params = '&';
        //For Radio Button - Visibility
        if ($scope.postOpts.privateFlagStr === 'recruiterOnly') {
            params += 'privateFlag=true&internal=false&';
        } else if ($scope.postOpts.privateFlagStr === 'internal') {
            params += 'internal=true&privateFlag=false&';
        } else {
            params += 'privateFlag=false&internal=false&';
        }

        //For Checkbox - Distribution Options
        if ($scope.distributionOptions['jobNotification'] === true && $scope.postOpts.privateFlagStr === 'external') {
            params += 'notification=true&';
        } else {
            params += 'notification=false&';
        }
        if ($scope.distributionOptions['internalCareerSite'] === true || $scope.distributionOptions['externalCareerSite'] === true) {
            params += 'careerSite=true';
        } else {
            params += 'careerSite=false';
        }
        if($scope.showIntegrationOptions) {
            angular.forEach($scope.integrations, function(integration) {
                params += ('&' + integration.type + '=' + (integration.entityStatusValue ? 'ENABLED' : 'DISABLED'));
            });
        }

        // handling limited requisitions scenario when the user removes
        // ownself from hm list & does not qualify in the list of
        // allowed roles to limited access roles
        if (!$scope.hasAccessToLimitedAccessJob && isLimitedAccessJob() && !(checkUserInUserListByFieldId(window._jvselfUser.eid, -17) || checkUserInUserListByFieldId(window._jvselfUser.eid, -16))) {
            showLimitedRequisitionNotAllowed();
            return;
        }

        // If Trying to submit/open requisition, validate
        var isAction = Boolean(action);
        if (isAction) {
            var emptyRequiredFields = emptyReqdFields() || [];
            if (_fail && hireCustomer) {
                $scope.scrollTo('toVisibility');
                $scope.visibilityMissing = true;
                scrolled = true;
            }
            if (emptyRequiredFields.length > 0) {
                if (!scrolled) {
                    scrollToEmptyField(emptyRequiredFields);
                    scrolled = true;
                }
            }
            if (emptyRequiredFields.length > 0 || (_fail && hireCustomer) || !$scope.validate(action)) {
                return;
            }

            params += '&actionName='+action;
            if (action === 'SFA') {
                // ToDo: use cached value
                if (mId) {
                    params += '&mId=' + $scope.urlParams()['mId'];
                }
            }
        } else {
            //Number fields has to be validated even we Save form As Draft
            if (!$scope.validate()) {
                return;
            }
        }

        //sending postData instead of sending $scope.result
        var postData = angular.copy($scope.result);
        postData = mergePrimaryAndOtherHM(postData);
        if (postData.otherHM) {
              delete postData.otherHM;
        }
        postData = mergePrimaryAndOtherRecruiters(postData);
        if (postData.otherRecruiters) {
               delete postData.otherRecruiters;
        }

        $scope.validationError = false;
        $scope.flags.loading = true;
        if (action === 'BULK') {
            return postData;
        }
        // Copying '$scope.result' so that any manipulations during serialization does not affect the original object.
        Reqs.save(postData, params, function(response) {
            //Save success. Call Totango code here.
            jvTotango.track('Create New Requisition', 'Requisitions');
            var url, data = response.data;
            if (jQuery.fn.jquery.split('.')[0] === '3') {
                $(window).off('beforeunload');
            } else {
                $(window).unbind('beforeunload');
            }
            $scope.dupReqIdError = false;
            if (data.msgInfo === 206) {
                $scope.flags.loading = false;
                $scope.showMsg('DUP_REQ_ID', false, 'error');
                $scope.dupReqIdError = true;
            } else if(data.msgInfo === 406) {
                postSubmitHMErrors(i18n.INACTIVE_LOCATION_HEADING, i18n.INACTIVE_LOCATION_BODY, i18n.OK, false);
                 $scope.flags.loading = false;
            } else if (data.msgInfo === 412) {
                $scope.flags.loading = false;
                $scope.alertLanguageNotSupported(true);
            }else if (action && data.msgInfo === 417) {
                $scope.flags.loading = false;
                postSubmitHMErrors(i18n.NOACCESS_TO_REQUIRED_FIELDS_HEAD, i18n.NOACCESS_TO_REQUIRED_FIELDS_MSG, i18n.SAVE_AS_DRAFT, true, i18n.CANCEL, function ok() {
                    save();
                });
            }else if (action === 'SFA') {
                url = '../../modules/requisitions/approve.html?j=' + data.EId + '&readMode=0';
                if (mId) {
                    url += '&mId=' + mId;
                }
                $window.location = url;
            } else if (action === 'OPEN') {
                Reqs.post({
                    id: data.EId,
                    readMode: 0
                }, function() {
                    window.location = '../../modules/requisitions/tabs.html?readMode=0#/details/' + data.EId;
                });
            } else if ($scope.params.id && !$scope.copyFlow) {
                if (data.hasOwnProperty('views')) {
                    $scope.requisitions.views = data.views;
                }
                $location.path(('/details/' + $scope.params.id + '/' + $scope.params.index + '/' + $scope.params.count + '/' + $scope.params.query).replace(/\/undefined/gi, '')).search('readMode=0');
            } else {
                window.location = '../../modules/requisitions/tabs.html?readMode=0#/details/' + data.EId;
            }
        }, {
            id: $scope.params.id,
            readMode: ($scope.addOrEdit === 'edit'),
            validate: false,
            copyFlow: $scope.copyFlow,
            notifyAgency: hasNotifyAgencyChange() ,
            error: function(response) {
                if (response === 'invalid') {
                    $scope.validationError = true;
                    //window.scrollTo(0,0);
                    $('body,html').animate({
                        scrollTop: 30
                    }, 800);
                }
            }
        });
    };

    var checkForStatusChangeAlert = function(action) {
        var emptyFields = emptyReqdFields();
        if ((emptyFields || []).length) {
            postStatusChangeModal(i18n.REQUISITION_STATUS_CHANGE, i18n.REQUISITION_STATUS_CHANGE_TEXT, function ok() {
                save(action);
            }, function cancel() {
                scrollToEmptyField(emptyFields);
            });
        } else {
            save(action);
        }
    };

    $scope.save = function(action) {
        $scope.incompleteRequired = {};
        var _titleEmpty = (angular.isUndefined($scope.result[$scope.titleField]) || $scope.result[$scope.titleField] === '');
        if (_titleEmpty) {
            $scope.scrollTo('field' + $scope.titleField);
            scrolled = true;
            $scope.titleError = true;
            $scope.incompleteRequired[$scope.titleField] = 0;
            return;
        }

        // handling limited requisitions scenario when the user removes
        // ownself from hm list & does not qualify in the list of
        // allowed roles to limited access roles
        if (!action && !$scope.hasAccessToLimitedAccessJob && isLimitedAccessJob() && !(checkUserInUserListByFieldId(window._jvselfUser.eid, -17) || checkUserInUserListByFieldId(window._jvselfUser.eid, -16))) {
            showLimitedRequisitionNotAllowed();
            return;
        }

        if (!action && $scope.addOrEdit === 'edit' && $scope.requisitions?.jobDetails?.jobState !== 'Draft') {
            /*
             =================================================================================================================================
             BUG#13667
                 * Checking if User has only HM role should not remove himself from requisition
                 * as the job will no longer be accessible to him
             ================================================================================================================================= */
            if (!isCurrentHMselected()) {
                if (!$scope.hasOwnJobAccess) {
                    postSubmitHMErrors(i18n.HMONLY_REMOVED_SELF_MSG_HEAD, i18n.HMONLY_REMOVED_SELF_MSG, i18n.SAVE, true, i18n.CANCEL, function ok() {
                        $scope.modal.show = false;
                        checkForStatusChangeAlert(action);
                    });
                } else {
                    postSubmitHMErrors(i18n.JOBOWNER_REMOVED_SELF_MSG_HEAD, i18n.JOBOWNER_REMOVED_SELF_MSG, i18n.SAVE, true, i18n.CANCEL, function ok() {
                        $scope.modal.show = false;
                        $scope.jobOwnerRemoved = true;
                        checkForStatusChangeAlert(action);
                    });
                }
            } else {
                checkForStatusChangeAlert(action);
            }
        } else {
            if (isCurrentHMselected()) {
                if (!action) {
                    save(action);
                } else {
                        //User who doesnt have access to HR Restricted required field, should not be able to submit requisition for approval
                        if ($scope.hasHRRestrictedRequiredFields) {
                            postSubmitHMErrors(i18n.NOACCESS_TO_REQUIRED_FIELDS_HEAD, i18n.NOACCESS_TO_REQUIRED_FIELDS_MSG, i18n.SAVE_AS_DRAFT, true, i18n.CANCEL, function ok() {
                                save();
                            });
                        } else {
                            save(action);
                        }
                }
            } else {
                if (!$scope.hasOwnJobAccess) {
                    if (!action && $scope.requisitions.jobDetails && $scope.requisitions.jobDetails.jobState === 'Draft') {
                        postSubmitHMErrors(i18n.HMONLY_REMOVED_SELF_MSG_HEAD, i18n.HMONLY_REMOVED_SELF_MSG, i18n.SAVE, true, i18n.CANCEL, function ok() {
                            save(action);
                        });
                    } else {
                        postSubmitHMErrors(i18n.HMONLY_REMOVED_SELF_MSG_HEAD, i18n.HMONLY_REMOVED_SELF_SUBMITTING_APPROVAL_MSG, i18n.OK, false, '', function ok() {
                            $scope.modal.show = false;
                        });
                    }
                } else {
                    //RBAC: when logged-in user is removed from Job-Owner's list
                    if (!action) {
                        postSubmitHMErrors(i18n.JOBOWNER_REMOVED_SELF_MSG_HEAD, i18n.JOBOWNER_REMOVED_SELF_MSG, i18n.SAVE, true, i18n.CANCEL, function ok() {
                            save(action);
                        });
                    } else {
                        postSubmitHMErrors(i18n.JOBOWNER_REMOVED_SELF_MSG_HEAD, i18n.JOBOWNER_REMOVED_SELF_SUBMITTING_APPROVAL_MSG, i18n.OK, false, '', function ok() {
                            $scope.modal.show = false;
                        });
                    }
                }
            }
        }
    };

    var hasPostOptionsChanged = function() {
        var changed = false;
        var postOptChanges = {};
        if ($scope.postOpts.privateFlagStr === 'recruiterOnly') {
            postOptChanges['privateFlag'] = true;
            postOptChanges['internal'] = false;
        } else if ($scope.postOpts.privateFlagStr === 'internal') {
            postOptChanges['privateFlag'] = false;
            postOptChanges['internal'] = true;
        } else {
            postOptChanges['privateFlag'] = false;
            postOptChanges['internal'] = false;
        }

        //For Checkbox - Distribution Options

        if ($scope.distributionOptions['jobNotification'] === true && $scope.postOpts.privateFlagStr === 'external') {
            postOptChanges['notification'] = true;
        } else {
            postOptChanges['notification'] = false;
        }
        if ($scope.distributionOptions['internalCareerSite'] === true || $scope.distributionOptions['externalCareerSite'] === true) {
            postOptChanges['careerSite'] = true;
        } else {
            postOptChanges['careerSite'] = false;
        }

        $.each($scope.requisitions.postOptions, function(key) {
            if ($scope.requisitions.postOptions[key] !== postOptChanges[key]) {
                changed = true;
            }
        });
        return changed;
    };

    var hasAnyFieldChanged = function() {
        var changed = false;
        $.each($scope.requisitions.viewFields, function(eid, field) {
            if (isEditable(field) && !isFieldSame(field)) {
                changed = true;
                return false;
            }
        });

        /*Checking if postOptions have changed*/
        if (!changed) {
            return hasPostOptionsChanged();
        } else {
            return changed;
        }

    };

    $scope.navAway = function(confirm) {
        if (hasAnyFieldChanged()) {
            if (confirm) {
                return confirm(i18n.NAV_AWAY_WARNING_MESSAGE);
            }
            return i18n.NAV_AWAY_WARNING_MESSAGE;
        }
    };

    $scope.validateCurrency = function(value) {
        var pat = new RegExp(/^\$?([1-9]{1}[0-9]{0,2}(\,[0-9]{3})*(\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\.[0-9]{0,2})?|0(\.[0-9]{0,2})?|(\.[0-9]{1,2})?)$/g);
        return !pat.test(value);
    };


    /**
     * Adding event for showing the leave page confirmation.
     */
    angular.element($window).on('beforeunload', function() {
        if (isBulkEditReqsPageActive) {
            return;
        }
        return $scope.navAway();
    });


    var findFirstEmptyRequiredDateField = function() {
        var className = 'date-field';
        var dateFields = $('.' + className);
        var length = dateFields.length;
        for (var i = 0; i < length; i++) {
            var data = $(dateFields[i]).val();
            if (!data) {
                return dateFields[i];
            }
        }
    };
    /**
     * This function is used to scroll to a required element
     * @params  id of the element
     */
    $scope.scrollTo = function(id) {
        var top;
        //date fields dont have id field
        if ($('#' + id).length === 0) {
            //use class name to get the firstEmptyRequiredDateField
            var firstEmptyRequiredDateField = findFirstEmptyRequiredDateField();
            top = $(firstEmptyRequiredDateField).offset().top;
        } else {
            top = $('#' + id).offset().top;
        }
        window.isnextGenUIEnabled === 'true' && (top = top - 68);
        $('html,body').animate({
            scrollTop: top
        }, 400);
    };


    /**
     * ToDo: Code Smell: Too many return points from the function.
     * @returns {boolean}
     */
    $scope.validate = function(action) {
        // var title = $scope.result[$scope.titleField];

        if (action === 'SFA') {
            if ($scope.isNextDisabled() || anyReqdFieldsEmpty()) {
                $scope.showError = true;
                return false;
            }
        }

        // if( $scope.titleField && !title.trim()){
        //     $scope.validationError = true;
        //     var id = 'field'+$scope.titleField;
        //     var top = $('#'+id).offset().top;
        //     $('html,body').animate({ scrollTop: top }, 400);
        //     return false;
        // }else{
        //     $scope.validationError = false;
        // }

        $scope.numberValError = false;
        angular.forEach($scope.requisitions.viewFields, function(vfield) {
            if (vfield.fieldType === 'Number' || vfield.fieldType === 'Amount') {
                if (!vfield.readOnly && !vfield.addNumberFormatMasking) {
                    var fieldValue = $scope.result[vfield.EId];
                    if (fieldValue && !!fieldValue.trim() && $scope.isNumberValid(fieldValue)) {
                        $scope.numberValError = true;
                        var id = 'field' + vfield.EId;
                        $scope.scrollTo(id);
                    }
                }
            }
        });

        //Validation for brief description field
        // if($('.error:visible').length > 0){
        //     var elem = $('.error').parent();
        //     $scope.scrollToRequired(elem);
        //     return ($('.error:visible').length==1 && $scope.dupReqIdError)?true:false;
        // }
        return !$scope.numberValError;
    };


    $scope.isNaN = isNaN;
    /**
     *
     * @returns {String}
     */
    $scope.validationClass = function(field) {
        if ((field.fieldType === 'Number' || field.fieldType === 'Amount') && $scope.result[field.EId] && !!$scope.result[field.EId].trim() && $scope.isNumberValid($scope.result[field.EId])) {
            return 'validationError';
        }
        if(field.fieldId === -21 && $scope.agencyOpts.enableJobModifyNotificationAgency && $scope.addOrEdit === 'edit' && $scope.agencyOpts.isJobOpen){
        $scope.agencyOpts.showCheckbox=!$scope.isEmpty(field);
        }
        return;
    };
    /** Extract only text to calculate typed chars length for Wysiwyg fields**/
    $scope.extractText = function(modelValue) {
        if (angular.isString(modelValue)) {
            var space = /&nbsp;/g;
            modelValue = modelValue.replace(space, ' ');
            var pat = /<(.|\n)*?>/g;
            return modelValue.replace(pat, '');
        }
    };
    $scope.$on('textPastedResDesc', function(event, data) {
        document.getElementById(data.id+'helperText').style.display = 'flex';
    });
    /*
    For Edit req, on page load $.isEmptyObject(uploads) && $scope.params.id is true. To avoid the value sent by the backend being set to empty string we are setting this flag.
     */
    $scope.deleteAfterUpload = false;
    $scope.uploadError = {};
    $scope.$watch('wysiwygAjaxContent', function(newVal) {
        if ($.isEmptyObject(newVal)) {
            return;
        }
        angular.forEach(newVal, function(uploads, field) {
            if (!$scope.deleteAfterUpload) {
                $scope.deleteAfterUpload = true;
                return;
            }

            //This used to be for setting the field to blank on delete of the file, but this is no longer necessary.
            if (($.isEmptyObject(uploads) && !$scope.params.id) || ($.isEmptyObject(uploads) && $scope.params.id)) {
                //$scope.result[field] = '';
            } else {
                $scope.uploadError[field] = false;
                //Else You want to set the result[field] to the filecontent
                angular.forEach(uploads, function(value, key) {
                    if (uploads.hasOwnProperty(key) && angular.isString(value.resourceInfo.fileContent)) {
                        var fileContent = value.resourceInfo.fileContent;
                        if (value.resourceInfo.fileName.match(/\.pdf/)) {
                            fileContent = fileContent.replace(new RegExp('\n', 'g'), '<br />');
                        }
                        $scope.result[field] = '<div>' + fileContent + '</div>';
                        $scope.$broadcast('descfileUploadComplete',fileContent, field);
                    } else {
                        $scope.uploadError[field] = true;
                    }
                });
            }
        });
    }, true);

    /**
     * Filters an array of object literals based on the value passed as the argument.
     * Changed '===' to '==' as itemValue.key is encrypted Id in string format for location and other cases like Job Type
       itemValue.key is Numeric so comparing by only equal values.
     */

    $scope.filterOnKey = function(values, value) {
        var result = [];
        angular.forEach(values, function(itemValue) {
            if (itemValue.value === value || itemValue.key == value) {//eslint-disable-line
                result.push(itemValue.value);
            }
        });
        return result[0];
    };

    $scope.renderSecondaryLocationField = function(fields){
        var result = '';
        var locationField = fields.filter(function(field){ return field.fieldId === -8; });
        if(locationField && locationField.length > 0){
            var data = locationField.pop().data;
            if(data && angular.isArray(data) && (data.length > 0)){
                result = ',' + data.map(function(location){ return location.name;},'').join(', ');
            }
        }
        return result;
    };
    
    $scope.filterOnKeyAndReturnObj = function(values, value) {
        var result = [];
        angular.forEach(values, function(itemValue) {
            if (itemValue.value === value || itemValue.key === value) {
                result.push(itemValue);
            }
        });
        return result[0];
    };

    /**
     *
     * Used to find the field is Driven field or not based on fieldId.
     * @param fieldId     : fieldId of the field.
     * @returns {Boolean} : true if the field is driven else false .
     *
     */
    $scope.isDrivenField = function(fieldId) {
        return !!($scope.drivenFields.indexOf(fieldId) > -1 && $scope.skipableDrivenFields.indexOf(fieldId) < 0);
    };

    /**
     * Used to highlight the driven fields
     *
     */
    $scope.$watch('highlightDrivenField', function(newVal, oldVal, $scope) {
        if (newVal) {
            $timeout(function() {
                $scope.highlightDrivenField = _noTriggerDummy;
            }, 2000);
        }
    });

    var resetField = function(field, isFieldList) {
        if (!isFieldList) {
            _setModelValue(field, '');
        } else {
            angular.forEach(field, function(fld) {
                var _vf = $filter('filter')($scope.requisitions.viewFields, {
                    fieldId: fld
                }, true)[0];
                if (_vf) {
                    _setModelValue(_vf, '');
                }
            });
        }
    };

    /**
     * Used to render the driven fields of the driven
     * @param driver
     *
     */

    $scope.renderDrivenFields = function(driver, editMode) {

        if ($scope.requisitions.fieldMappings[driver.fieldId]) {
            var fieldValue, fieldKey,
                controls = $scope.requisitions.fieldMappings[driver.fieldId];
            var skipNextRequest = false;

            var extendControls = function(controls) {
                var tempArr = angular.copy(controls);
                var fieldMapped;
                angular.forEach(controls, function(controlled) {
                    fieldMapped = $scope.requisitions.fieldMappings[controlled];
                    if (fieldMapped) {
                        tempArr.push.apply(tempArr, fieldMapped);
                    }
                });
                return tempArr;
            };

            if (editMode) {
                sanitize(driver);
                fieldKey = driver.value;
                fieldValue = driver.value;
                if (fieldKey === '' && angular.isUndefined(driver.values)) {
                    skipNextRequest = true;
                }
            } else {
                fieldValue = $scope.result.DropDown[driver.EId];
                //If other locations are in object form, when we click on edit, setting eids to it so that call goes for fetching locations from backend.
                 //This "If" condition is invoked after clicking on edit and changing the locations.
                if (driver.fieldId === -8 && angular.isDefined($scope.result['otherLocations']) && $scope.result['otherLocations'].length>0 && angular.isDefined($scope.result['otherLocations'][0].EId)) {
                        var secondaryLocations=$scope.result['otherLocations'];
                        $scope.result.otherLocations = [];
                        //Setting eids to fetch location from backend
                        angular.forEach(secondaryLocations, function(location) {
                            $scope.result.otherLocations.push(location.EId);
                        });
                        var locations = [];
                        locations = $scope.createLocationObject(fieldValue);
                        //Call to check whether all the locations set are from same country
                        if(locations.length>1 && fieldValue!==null && angular.isDefined(fieldValue)) {
                            $scope.differentLocationsSelected = $scope.isLocationChangeValid(locations);
                        } else {
                            //Clearing out locations and resetting the scope variables
                            $scope.differentLocationsSelected=false;
                            $scope.result.otherLocations = [];
                        }
                }
                fieldKey = angular.isObject(fieldValue) ? fieldValue.key : fieldValue;
                fieldValue = fieldValue && fieldValue.value;
            }

            if (!editMode && !driver._skipFieldMapRequest) {
                var resetableFields = extendControls(controls);
                if (fieldValue && fieldValue !== '') {
                    resetField(resetableFields, true);
                    $scope.skipableDrivenFields = $scope.skipableDrivenFields.concat(controls);
                    $scope.setDrivenFieldValue(controls, fieldKey, driver, false);
                    $scope.highlightDrivenField = resetableFields;
                } else {
                    $scope.hideDrivenFields(resetableFields);
                    resetField(driver);
                    resetField(resetableFields, true);
                    $scope.highlightDrivenField = _noTriggerDummy;
                }
            } else {
                if (typeof driver._skipFieldMapRequest === 'undefined') {
                    driver._skipFieldMapRequest = skipNextRequest ? false : true;
                    angular.forEach(controls, function(controlled) {
                        var field = $filter('filter')($scope.requisitions.viewFields, {
                            fieldId: controlled,
                            parentId: driver.fieldId
                        })[0];
                        if (field) {
                            sanitize(field);
                            if ((!field.value || field.value === '') && !field.visible) {
                                hideFields.push(field.fieldId);
                            }
                        }
                    });
                    if (hideFields.length) {
                        $scope.hideDrivenFields(hideFields);
                    }
                } else if (driver._skipFieldMapRequest === true) {
                    driver._skipFieldMapRequest = false;
                }
            }
        } else if (!$scope.requisitions.fieldMappings[driver.fieldId] && driver.fieldId === -8 && angular.isDefined($scope.result['otherLocations']) && $scope.result['otherLocations'].length > 0 && angular.isDefined($scope.result.DropDown[driver.EId]) && angular.isDefined($scope.result['otherLocations'][0].EId)) {
            // setting other location array as blank
            $scope.result.otherLocations = [];
        }
    };

    $scope.isLocationChangeValid =function(locations) {
        Reqs.checkIfLocationChangeValid(locations, function(response) {
                 $scope.differentLocationsSelected=false;
                 if(!response.result){
                    $scope.differentLocationsSelected=true;
                 }
         });
    };

    $scope.createLocationObject = function(fieldValue) {
        var locations = [];
        if(fieldValue!==null && angular.isDefined(fieldValue)) {
           if(angular.isObject(fieldValue)) {
                locations.push(fieldValue.key);
           } else {
               locations.push(fieldValue);
           }
        }
        angular.forEach($scope.result.otherLocations, function(eachLocation) {
                angular.isObject(eachLocation)? locations.push(eachLocation.EId):locations.push(eachLocation);
        });
        return locations;
    };

    $scope.$watch('result.otherLocations',function(newVal,oldVal) {
    if(!angular.equals(newVal,oldVal)) {
        $scope.otherLocationsChangeOccured=true;
        var locationDriverEid=null;
        //To get the value of driver, first get its EId
        var viewFields = $scope.requisitions.viewFields;
            angular.forEach(viewFields,function(viewField) {
                if(angular.isDefined(viewField) && (viewField.fieldId=== -8)) {
                    locationDriverEid = viewField.EId;
                }
            });
            var locations = [];
            //Then, from Eid we need to get driver value
            var fieldValue = $scope.result['DropDown'][locationDriverEid];
            locations = $scope.createLocationObject(fieldValue);
            //This logic is added to check message should disappear if, either all the entries are cleared from otherlocations or leftout entries are of same country as primary location
            if(angular.isDefined(newVal) && (newVal.length===0 || $scope.isLocationChangeValid(locations))) {
                $scope.differentLocationsSelected=false;
            }
        }

    });

    var filterMappedValue = function(mappedValues, mappedValue, fieldValue, fieldValueObj, employeePattern, pattern, callFieldList, init) {
        $filter('filter')($scope.requisitions.viewFields, function(viewField) {
            if (viewField.fieldId === parseInt(mappedValue)) {
                angular.extend(viewField, {
                    mappedValues: mappedValues[mappedValue].values,
                    mappedValue: mappedValues[mappedValue].value
                });

                //It should go inside if its not initialization or if its employee readOnly field during initialization
                if (!init) {
                    fieldValue = viewField.mappedValues;
                    if (fieldValue) {
                        fieldValueObj = fieldValue;
                        fieldValue = !angular.isUndefined(viewField.mappedValue) ? viewField.mappedValue : fieldValue[0].key;
                    }
                    if (viewField.readOnly || !(pattern.test(viewField.fieldType))) {
                        _setModelValue(viewField, fieldValue);
                        viewField.values = fieldValueObj;
                    }
                    //If driven field is of DropDown type and has only one option, It should be pre-selected.
                    if (!viewField.readOnly && employeePattern.test(viewField.fieldType) && angular.isArray(viewField.mappedValues) && viewField.mappedValues.length === 1) {
                        //Should avoid setting model if field is read only
                        var _userObj = {
                            EId: fieldValueObj[0].key,
                            fullName: fieldValueObj[0].value
                        };
                        _setModelValue(viewField, _userObj);
                    }
                    //TemporaryFix: -61 -> Associate Owner Field. This is added so that field mapping for employee multi select works. Needs to be cleaned up
                    //and made more generic.
                    if (viewField.fieldId === -61) {
                        viewField.normalized = false;
                        $scope.result.Array[viewField.EId] = [];
                        angular.forEach(viewField.mappedValues, function(usr) {
                            $scope.result.Array[viewField.EId].push({
                                EId: usr.key,
                                fullName: usr.value
                            });
                        });
                    } else {
                        viewField.value = fieldValue;
                    }
                    if(viewField.renderedType === 'Content'){
                        _setModelValue(viewField,fieldValue);
                    }
                    callFieldList.splice(callFieldList.indexOf(viewField.fieldId), 1);
                }
            }
        });
    };

    /**
     * Used to set the values for driven fieldlist which passed based on driverValue
     * @param fieldList {Array}    : Driven fieldId list
     * @param driverValue {String} : Driver value
     */
    $scope.setDrivenFieldValue = function(fieldList, fieldKey, parentField, init) {
        var callFieldList = angular.copy(fieldList),
            params = '&fieldIds=' + callFieldList.join('&fieldIds='),
            fieldValue, fieldValueObj;

        if (callFieldList.length > 0) {
            if (!init) {
                $scope.flags.loading = true;
            }
            Reqs.getAndSetMappedValues(params, fieldKey, parentField.fieldId, function(response) {
                if (response) {
                    var mappedValues = response.drivenFieldsMappings;
                    var employeePattern = /Employee/i;
                    var pattern = /Employee|DropDown/i;
                    for (var mappedValue in mappedValues) {
                        filterMappedValue(mappedValues, mappedValue, fieldValue, fieldValueObj, employeePattern, pattern, callFieldList, init);
                    }
                }
                if (!init) {
                    if (callFieldList.length) {
                        $scope.hideDrivenFields(callFieldList);
                        resetField(callFieldList, true);
                    }
                    $scope.flags.loading = false;
                }
            });
        }
    };

    /**
     * Used to have the triggeredFields object in $scope param as key as driven fieldId and value as driven field object.
     * This Object used while rendering the driven fields on driver field change.
     *
     */
    $scope.fieldMapPreProcess = function() {

        var triggeredFields = $scope.requisitions.triggeredFields,
            driverList = [],
            empDriven = {};
        var pattern = /Employee/i;

        //To increas the performence having the triggered fields in array where as key is the fieldId.So when we required we no need to go and check in all the fields we can use it in direct .
        $scope.requisitions._triggeredFields = {};

        $scope.drivenFields = $scope.requisitions.triggeredFields;

        angular.forEach($scope.requisitions.viewFields, function(field) {
            if ((pattern.test(field.fieldType)) && angular.isDefined(field.parentId)) {
                if (empDriven[field.parentId]) {
                    empDriven[field.parentId].push(field.fieldId);
                } else {
                    empDriven[field.parentId] = [field.fieldId];
                }
            }
            var driverValue = field.value,
                drivenFieldList = $scope.requisitions.fieldMappings[field.fieldId];
            if (triggeredFields.indexOf(field.fieldId) > -1) {
                field.hideField = true;
                $scope.requisitions._triggeredFields[field.fieldId] = field;
            }

            if (!!driverValue && drivenFieldList) {
                $scope.skipableDrivenFields = $scope.skipableDrivenFields.concat(drivenFieldList);
                driverList.push(field);
            }

        });

        angular.forEach(driverList, function(driver) {
            $scope.renderDrivenFields(driver, true);
            if (empDriven[driver.fieldId] && empDriven[driver.fieldId].length) {
                $scope.setDrivenFieldValue(empDriven[driver.fieldId], driver.value, driver, true);
            }
        });

    };
    /**
     * Used to hide the driven fieldList which passed to this method
     * @param fieldList{Array} : Driven FieldId List.
     */
    $scope.hideDrivenFields = function(fieldList) {
        var diff = jQuery.grep($scope.skipableDrivenFields, function(item) {
            if (jQuery.inArray(item, fieldList) < 0) {
                return true;
            }
        });
        $scope.skipableDrivenFields = diff;
    };

    //For loading tabs on page reload
    if (action === 'edit' && !$scope.requisitions.jobDetails) {
        $scope.header();
    }

    $scope.getAllIds = function(fieldObject) {
        if (angular.isDefined(fieldObject.mappedValues)) {
            var result = [];
            for (var i = 0; i < fieldObject.mappedValues.length; i++) {
                result.push(fieldObject.mappedValues[i].key);
            }
            return result.join(',');
        }
    };

    $scope.getParentValue = function(parentId) {
        if (parentId) {
            var _field, _fieldValue;
            angular.forEach($scope.requisitions.viewFields, function(field) {
                if (parentId === field.fieldId) {
                    _field = field;
                }
            });
            _fieldValue = $scope.modelVal(_field);
            if(_fieldValue == null && _field.value){
                _fieldValue = _field.value;
            }
            _fieldValue = angular.isObject(_fieldValue) ? _fieldValue.key : _fieldValue;
            return _fieldValue;
        }
    };

    $scope.reloadMultiLocationField = function() {
        $scope.loadLocationSelect = false;
        $timeout(function() {
            $scope.loadLocationSelect = true;
        }, 200);

    };

    $scope.openJobGrader = function (e, formName) {
        e.preventDefault();
        window.jobGrader.submit({
            title: $scope.result[$scope.titleField],
            jd: formName
        });
    };

    $scope.previewApplyForm = function(formId, formName) {
        $scope.applyFormName = formName;
        $scope.applyFormFields = null;
        $scope.modals = {
            applyFormPreview: true
        };
        ApplyFormPreviewService.getForm(formId).then(function(fields) {
            $scope.applyFormFields = fields;
        });
    };

    $scope.previewDisclaimer = function(jobDescription) {
        var disclaimerContent = window.aiDisclaimerContent || '';
        var content = '<div style="padding:50px 100px; font-family: sans-serif;">';
        content += '<h2 style="margin-bottom: 20px;">Job Description</h2>';
        content += jobDescription || '';
        
        if (disclaimerContent) {
            content += '<div style="margin-top: 40px;">';
            content += '<h4 style="margin-bottom: 5px; font-size: 13px">AI Disclaimer</h4>';
            content += '<p style="font-style: italic; font-size: 13px; color: #555; margin:0px">' + disclaimerContent + '</p>';
            content += '</div>';
        }
        content += '</div>';
        
        var w = 1000;
        var h = 1000;
        var x = screen.width/2 - (w/2);
        var y = screen.height/2 - (h/2);
        var previewWindow = window.open('', 'previewDisclaimerWindow', 'width='+w+',height='+h+',left='+x+',top='+y+',scrollbars=yes');
        previewWindow.document.open();
        previewWindow.document.write(content);
        previewWindow.document.close();
        previewWindow.document.body.style.overflow = 'auto';
        previewWindow.document.body.style.height = '100%';
        previewWindow.document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        previewWindow.focus();
    };

    $scope['CheckBox'] = {};
    $scope.$watch('result["CheckBox"]', function (checkBoxes, oldCheckBoxes) {
        angular.forEach(checkBoxes, function (checkedValues, id) {
            $scope['CheckBox'][id] = $scope['CheckBox'][id] || {};
            if (!($.isEmptyObject(checkedValues))) {
                for (var v in checkedValues) {
                    if (checkedValues[v]) {
                        $scope['CheckBox'][id].hasValues = true;
                        break;
                    } else {
                        $scope['CheckBox'][id].hasValues = false;
                    }
                }
            }

            /**
               * this code is required to show warning message when user selects careersite option when limited access
               * option is selected. this requirement was implemented when postingTypes and publishingOptions were hardcoded,
               * there is no way to support this behaviour in the current driver-driven field architecture
               * because of it being an unsual scenario.
               */

            var postingType = $scope.fieldIdMap[-68];
            var publishingOptions = $scope.fieldIdMap[-69];
            var isLimitedAccessPostingType = postingType && $scope.result['DropDown']?.[postingType]?.key === '2';
            if (publishingOptions && oldCheckBoxes?.[publishingOptions] &&
                isLimitedAccessPostingType && !oldCheckBoxes[publishingOptions]['CAREERSITE'] &&
                checkBoxes?.[publishingOptions]?.['CAREERSITE']) {
                $timeout(function () {
                    $scope.confirmCheckWithPrivateFlag();
                }, 100);
            }

        });
    }, true);

    $scope.$on('allRequiredFieldsFilled', function(event, allRequiredFieldsFilled) {
        if (allRequiredFieldsFilled) {
            $scope.$apply(function() {
                $scope.showMsg('ALL_REQUIRED_FIELDS_COMPLETE');
            });
        }
    });
    $scope.isIncompleteRequiredField = {};
    $scope.isFindEditable = function (field) {
        return isEditable(field);
    };
    $scope.isFindUpdated = function (field) {
        return isFieldSame(field);
    };
    $scope.bulkEditModalOK = function () {
        $scope.locked = false;
        $scope.result.unlocked = true;
        $scope.lockToggle = 'ico-unlock';
        $scope.buttons.SFA = $scope.isSFAFlowEnabled;
    };
    $scope.getPostPayloadData = function () {
        const postData = save('BULK');
        if (postData) {
            return postData;
        }
        return {};
    };
    $scope.processBulkFormData = function (response) {
        return processFormData(response);
    };
}
]);
/**
 * All the Why's:
 *
 * 1) isFieldSame: Normalize: Code smell cosidering the function should not be tampering with the old or new values and use them as it is.
 *                            To overcome the case of undefined and '', I could have done field.value = field.value || '' in the type function
 *                            so that there is some value(i.e. '') in $scope.result. But the problem with doing it is it adds an entry into the
 *                            $scope.result which means additional fields to be processes and also this will be passed to the server(though it doesn't
 *                            affect anything)
 */
